import { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Grid,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import CloseICon from "../../assets/images/close-icon.svg";
import React from "react";
import { useSelector } from "react-redux";
import { popupEnum } from "../../utils/constants/order";
import { useTranslation } from "react-i18next";

const ActionModal = ({
  open,
  setOpen,
  title,
  clickHandler,
  loading,
  gateNo = "",
  driverRemark = [],
  currentUserType,
}) => {
  const [commentData, setCommentData] = useState({
    gate: "",
    comment: "",
  });
  const [gate, setGate] = useState(gateNo);
  const { updateOrderStatusApi } = useSelector((state) => state.orders);
  const {t} = useTranslation();

  useEffect(() => {
    setGate(gateNo);
  }, [gateNo]);

  useEffect(() => {
    const comments = { ...commentData };
    comments.gate = gate;
    setCommentData(comments);
  }, [gate, open])

  const modalStyle = {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 475,
    position: "absolute",
    backgroundColor: "white",
    boxShadow: 24,
    padding: 16,
    boxSizing: "border-box",
  };

  const handleChange = (event) => {
    const comments = { ...commentData };
    comments.comment = event.target.value;
    setCommentData(comments);
  };

  const handleChangeGate = (event) => {
    setGate(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    clickHandler(commentData);
    const comments = { ...commentData };
    comments.gate = "";
    comments.comment = "";
    setCommentData(comments);
  };

  return (
    <Modal open={open} onClose={setOpen} className="main-modal">
      <div style={modalStyle} className="modal-content">
        <div className="modal-body">
          <div className="modal-header action">
            <span onClick={() => setOpen(false)}>
              <img src={CloseICon} alt="" />
            </span>
          </div>
          <div className="modal-body action">
            <div className="action-reason">
              <h3>{driverRemark?.length > 0 ? t("driver_remarks") : t(popupEnum.label[title])}</h3>
            </div>
            {title === "on_hold/driver_arrived" && (
              <div classname="action-mandatory">
                <span style={{ fontSize: "1.3rem" }}>
                  {t("driver_confirm_description")}
                </span>
              </div>
            )}

            {title === "loading_delivered" && (
              <div classname="action-mandatory">
                <span style={{ fontSize: "1.3rem" }}>
                {t("delivery_complete_description")}
                </span>
              </div>
            )}
            {title === "loading_complete" && (
              <div classname="action-mandatory">
                <span style={{ fontSize: "1.3rem" }}>
                {t("loading_complete_instruction_sub")}
                </span>
              </div>
            )}
            {driverRemark?.length > 0 && (
              <div style={{ marginBottom: "1rem" }}>
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#2B2B2B",
                    marginBottom: "0.5rem",
                  }}
                >
                  {t("driver_remarks")}
                </Typography>
                <div
                  style={{
                    border: "1.5px solid #989CBB",
                    borderRadius: "0.75rem",
                    padding: "0.75rem",
                  }}
                >
                  {driverRemark.map((remark, index) => (
                    remark?.remarks !== 'null' && (
                    <div key={index} style={{ marginBottom: index < driverRemark.length - 1 ? "0.5rem" : 0 }}>
                      <Typography
                        sx={{
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#000",
                          lineHeight: "21px",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {remark?.remarks}
                      </Typography>
                      {remark?.time && (
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            color: "#989CB8",
                            fontWeight: "500",
                            marginTop: "0.25rem",
                          }}
                        >
                          {new Date(remark.time).toLocaleString()}
                        </Typography>
                      )}
                    </div> )
                  ))}
                </div>
              </div>
            )}
            <form onSubmit={handleSubmit}>
              {driverRemark?.length > 0 && (
                <div style={{ margin: "0 auto", textAlign: "center" }}>
                  <Typography sx={{ fontSize: "1.25rem", fontWeight: "500" }}>
                    { currentUserType === 0 ? t("distributor_instructions") : t("receiver_instructions")}
                  </Typography>
                </div>
              )}
              {(title === "ready" || title === "loading" || title === "ready_off_loading") && (
                <div className="action-textbox">
                  <TextField
                    fullWidth
                    label={t("gate_placeholder")}
                    variant="standard"
                    name="gate_no"
                    onChange={handleChangeGate}
                    value={gate}
                  />
                </div>
              )}
              <div className="action-textbox ">
                <TextField
                  fullWidth
                  label={t("comment_placeholder")}
                  variant="standard"
                  name="comment"
                  onChange={handleChange}
                  sx={{ marginTop: "1rem" }}
                  required
                />
              </div>
              <div className="input-group button">
                <Button
                  className="cursor"
                  type="submit"
                  variant="standard"
                  color="primary"
                  sx={driverRemark?.length > 0 ? {
                    width: "100%",
                    backgroundColor: "#2ECC71 !important",
                    color: "#fff !important",
                    textTransform: "capitalize",
                    marginTop: "10px",
                  } : {}}
                >
                  {updateOrderStatusApi?.loading && (
                    <CircularProgress
                      size={18}
                      style={{ marginRight: 10, color: "#fff" }}
                    />
                  )}
                  {driverRemark?.length > 0 ? (currentUserType === 0 ? t("distributor_instructions") : t("receiver_instructions") ) : t("submit")}
                </Button>
                {!(driverRemark?.length > 0) && (
                  <Button
                    className="cancel-button cursor"
                    onClick={() => setOpen(false)}
                  >
                    {t("cancel")}
                  </Button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ActionModal;
